import { PANDASCORE_LANG_TO_LOCALE } from './constants';

export const getLocaleFromLangForPandascore = (lang: string): string =>
  PANDASCORE_LANG_TO_LOCALE[lang] || PANDASCORE_LANG_TO_LOCALE.en;
